import { DOMAIN_CONFIG } from '../configs/main';

// Функция для добавления DMP трекинга для programmatic доменов
const addProgrammaticTracking = () => {
  // Добавляем DMP скрипт
  const dmpScript = document.createElement('script');
  dmpScript.async = true;
  dmpScript.type = 'text/javascript';
  dmpScript.src = 'https://dmp.programmatic.ru/assets';
  document.head.appendChild(dmpScript);
};

// Функция для добавления Yandex Metrika для programmatic доменов
const addProgrammaticYandexMetrika = () => {
  // Yandex Metrika скрипт для programmatic
  const yaScript = document.createElement('script');
  yaScript.type = 'text/javascript';
  yaScript.innerHTML = `
    (function (m, e, t, r, i, k, a) {
      m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) };
      m[i].l = 1 * new Date();
      for (var j = 0; j < document.scripts.length; j++) { if (document.scripts[j].src === r) { return; } }
      k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a)
    })
    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    
    ym(94151763, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    });
    
    ym(94602957, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
    });
  `;
  document.head.appendChild(yaScript);
};

// Функция для добавления трекинга для retargeo доменов
const addRetargeoTracking = () => {
  // Здесь можно добавить специфичные для retargeo трекинговые коды
  // Пока оставим пустым, можно будет добавить позже
  console.log('Retargeo tracking initialized');
};

// Главная функция для инициализации трекинга
export const initializeTracking = (config = DOMAIN_CONFIG) => {
  // Удаляем все существующие трекинговые скрипты
  const existingScripts = document.querySelectorAll('script[src*="dmp.programmatic.ru"], script[src*="mc.yandex.ru"]');
  existingScripts.forEach(script => script.remove());

  // Добавляем трекинг в зависимости от бренда
  switch (config.brand) {
    case 'programmatic':
      addProgrammaticTracking();
      addProgrammaticYandexMetrika();
      break;
    case 'retargeo':
      addRetargeoTracking();
      break;
    default:
      console.warn('Unknown brand for tracking:', config.brand);
  }
}; 